/* eslint-disable no-unused-vars */
import React from 'react';

import LoadingIcon from '@components/loading-lottie';
import Modal from '../..';
import Icon from '@components/icon-component';

import style from './style.module.scss';

const SaveModal = ({
  open,
  setOpen,
  inProgress = false,
  saveChanges = false,
  bookmarkSaveChanges = false,
  saving = false,
  onDiscard,
  onSave,
  disabledDeleteButton = false,
  saveInProgressNew,
  hideDiscardButton = false,
  showDiscardBtn = false
}) => {
  const saveModalIcon = React.useMemo(() => {
    if (inProgress) return <Icon name={'save-in-progress'} />;
    else if (saveChanges || bookmarkSaveChanges) return <Icon name={'save-in-progress'} />;
    else if (saving) return <LoadingIcon />;
  }, [inProgress, saveChanges, saving, bookmarkSaveChanges]);

  const statusText = React.useMemo(() => {
    if (saveInProgressNew) return 'Save as ‘In progress’?';
    else if (inProgress) return 'Save ‘In progress’?';
    else if (saveChanges) return 'Save changes?';
    else if (bookmarkSaveChanges) return 'Save bookmark changes?';
    else if (saving) return 'Saving';
  }, [inProgress, saveChanges, saving, bookmarkSaveChanges]);

  const modalTextUpper = React.useMemo(() => {
    if (saveInProgressNew)
      return 'You’ve edited the task and at least one required field is now empty. Saving now will move it to ‘In progress’.';
    else if (inProgress) return 'Would you like to save this task as ‘In progress’?';
    else if (saveChanges || bookmarkSaveChanges) return 'Would you like to save your changes?';
  }, [inProgress, saveChanges, bookmarkSaveChanges]);

  const textBtn = React.useMemo(() => {
    if (inProgress) return 'Back to form';
    else if (saveChanges) return 'Back to form';
    else if (bookmarkSaveChanges) return 'No thanks';
  }, [inProgress, saveChanges, bookmarkSaveChanges]);

  const modalBodyInner = React.useMemo(() => {
    if (inProgress)
      return (
        <div>
          <div className={style.modalBtn}>
            <button
              type="button"
              className="btn-fill button-large modal-btn-height"
              onClick={onSave}
            >
              {saveInProgressNew ? 'save as ‘in progress’' : 'Save'}
            </button>
          </div>
          {!saveInProgressNew && !hideDiscardButton && (
            <div className={style.modalBtn}>
              <button
                className={`btn-fill button-large ${
                  !disabledDeleteButton && style.discardBtn
                } modal-btn-height`}
                onClick={onDiscard}
                disabled={disabledDeleteButton}
              >
                Discard
              </button>
            </div>
          )}
        </div>
      );
    else if (saveChanges)
      return (
        <div>
          <div className={style.modalBtn}>
            <button
              type="button"
              className="btn-fill button-large modal-btn-height"
              onClick={onSave}
            >
              {saveInProgressNew ? 'save as ‘in progress’' : 'Save'}
            </button>
          </div>
          {!saveInProgressNew && !hideDiscardButton && (
            <div className={style.modalBtn}>
              <button
                className={`btn-fill button-large ${style.discardBtn} modal-btn-height`}
                onClick={onDiscard}
              >
                discard changes
              </button>
            </div>
          )}
        </div>
      );
    else if (bookmarkSaveChanges)
      return (
        <div>
          <div className={style.modalBtn}>
            <button
              type="button"
              className="btn-fill button-large modal-btn-height"
              onClick={onSave}
            >
              Save
            </button>
          </div>
        </div>
      );
  }, [inProgress, saveChanges, onSave, onDiscard, bookmarkSaveChanges]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      icon={saveModalIcon}
      statusText={statusText}
      modalTextUpper={modalTextUpper}
      textBtn={textBtn}
      modalImageClassName={saving && style.modalImage}
      modalTextUpperClass={style.modalTextUpperClass}
      sendingAgainPhotosAndDocuments={true}
    >
      {modalBodyInner}
    </Modal>
  );
};

export default SaveModal;
